class SideCart extends HTMLElement {
  constructor() {
    super();

    this.closeBtn = this.querySelector("#close_cart");
    this.overlay = this.querySelector(".sidecart__overlay");
    this.domain = `${Shopify.routes.root}`;
    this.subtotal = this.querySelector(".sidecart__subtotal");

    // necessary components to be rebuilt inside cart
    this.itemsContainer = this.querySelector(".sidecart__body");
    this.cartFooter = this.querySelector(".sidecart__footer");
    this.cartHeader = this.querySelector(".sidecart__header");
    this.freeShipping = this.querySelector(".sidecart__header-shipping");
    this.quantityBtns = this.querySelectorAll(".sidecart__update-btn");
    this.cartContent = this.querySelector(".sidecart__content");
    this.emptyCartContent = this.querySelector('.empty__cart');

    // cart icon bubble on header
    this.cartIconBubble = document.querySelector("#cart-icon-bubble");

    // constant elements
    this.CLOSEBTN = this.closeBtnIcon();
    this.PLUSBTN = this.plusBtnIcon();
    this.MINUSBTN = this.minusBtnIcon();
    this.FREESHIPPING = parseInt(window.sideCart.free_shipping) || 15000;
    this.FREESHIPPINGINTERNATIONAL =
      parseInt(window.sideCart.free_shipping_international) || 5000;
    this.CARTROUTES = "/cart";
    this.CHECKOUTBTNTXT = window.theme.checkout_text ? window.theme.checkout_text : "Checkout";
    this.EMPTYCARTTEXT = window.theme.empty__cart ? window.theme.empty__cart : "You have no items in your shopping cart.";

    // To prevent removing more than one product at a time
    this.isRemoving = false;

    // GWP button
    this.gwpInit();

    this.init();

    const sideCartStatus = localStorage.getItem("sidecart");
    if (sideCartStatus == "open") {
      this.openCart();

      localStorage.removeItem("sidecart");
    }

    this.swiperBundle = new Swiper(".swiper-container-minicart-bundle", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        autoplay: {
          delay: 2000,
        },
      },
    });

    this._mercer_boxer_gwp = null;
    this.originalGWPWidgetType = window.gwpData.widget_type;
  }



  init() {
    this.closeBtn.addEventListener("click", this.closeCart.bind(this));
    this.overlay.addEventListener("click", this.closeCart.bind(this));

    // Add actions tied to each quantity buttons
    this.quantityBtns.forEach((btn) => {
      btn.addEventListener("click", this.updateCart.bind(this, btn));
    });

    // Header cart icon will open the cart
    this.cartIconBubble.addEventListener("click", (e) => {
      e.preventDefault();
      this.openCart();
    });

  }

  async gwpInit() {
    if(window.theme.upsell_global_type == "disabled") return;
    /* await this.updateGWPDataFetch(); */
    this.gwpBtns = this.querySelectorAll(".gwpATC");
    this.gwpBtns &&
      this.gwpBtns.forEach((btn) => {
        btn.addEventListener("click", async (event) => {
          // add hidden class to .sidecart__gwp
          this.querySelector(".sidecart__gwp").classList.add("loading");
          this.querySelector(".sidecart__gwp .gwpATC").setAttribute("disabled", true);
          this.querySelector(".sidecart__gwp .gwpATC").classList.add("button");
          this.querySelector(".sidecart__gwp .gwpATC").classList.add("loading");

          const gwpInfo = {
            id: event.target.dataset.value,
            product_id: event.target.dataset.id,
            title: event.target.dataset.title,
            color: event.target.dataset.color,
            handle: event.target.dataset.handle,
            size: event.target.dataset.size,
            comparePrice: parseFloat(event.target.dataset.compare)
          };

          const itemId = event.target.dataset.value;
          const itemType = event.target.dataset.type;

          if (itemType == 'pack') {
            await this.generateGwpData(gwpInfo); 
          }else {
            await this.addToCart(
              itemId,
              1,
              gwpData.widget_type === "gwp" ? { _gift_item: true, _added_from_mini_cart: true } : {_added_from_mini_cart: true},
              {_added_from_mini_cart: true}
            );
            
          }   
          
          
        });
      });

  }

  async generateGwpData({ id, product_id, title, color, handle, size, comparePrice }) {
    if(window.theme.upsell_global_type == "disabled") return;
    const url = `https://www.mottandbow.com/products/${handle}.json`;
    const resultArray = color.split('/').map(item => item.trim());

    const requestedParts = [];
    const gwpPackDataATC = [];
    const bundleIndex = Date.now();

    const DummyPackId = id;
    const DummyPackTitle = title;

    resultArray.forEach((inputString) => {
      let textArray = inputString.trim().split(' ');
      let quantity = parseInt(textArray.pop());
      let color = textArray.join(' ');
      requestedParts.push({
        color_r: color,
        quantity_r: quantity,
      });
    });

    try {
      const response = await fetch(url);
      const jsonData = await response.json();
      const gwpVariants = jsonData.product.variants;

      function findProductByTitle(title) {
        return gwpVariants.find(v => v.title === title);
      }

      requestedParts.forEach((requestedVariant) => {
        const thisTitle = `${requestedVariant.color_r} / ${size}`;
        const foundVariant = findProductByTitle(thisTitle);

        if (foundVariant) {
          const discount = ((foundVariant.price / foundVariant.compare_at_price) * 100).toFixed(2);
          const finalObject = {
            id: foundVariant.id,
            quantity: requestedVariant.quantity_r,
            properties: {
              _gift_item: true,
              _added_from_mini_cart: true,
              _bundle_index: bundleIndex,
              _teepack: true,
              _discount: discount,
              _parent_id: DummyPackId,
              _parent_name: DummyPackTitle,
              _original_price: comparePrice,
              _total_price: foundVariant.price,
              "Original price": foundVariant.price,
              "Discounted price": foundVariant.price,
              _grandparent_id: product_id,
            },
          };
          gwpPackDataATC.push(finalObject);
        }
      });

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: gwpPackDataATC }),
      });

      this.getCart();
      return gwpPackDataATC;
    } catch (error) {
      console.error("Error GWP data:", error);
      return [];
    }
  }
  
  async updateGWPData(products_list, type) {
    // mubb-sssm-blac-dummy
    if(window.theme.upsell_global_type == "disabled") return;
    
    let related_prods_color = [];
    const products = products_list.split(",");
    let fit = '';
    if(type == 'main') {
      fit = window.gwpData.main_product.fit;
    } else if(type == 'second') {
      fit = window.gwpData.second_product.fit;
    } else if(type == 'boxer') {
      fit = window.gwpData._mercer_boxer_gwp_product.fit;
    }
    for(let i = 0; i < products.length; i++) {
      let productItem = products[i]; 
      // remove white spaces
      productItem = productItem.replace(/\s/g, '');
      if (productItem == '') {
        continue;
      }
      await fetch(`${Shopify.routes.root}products/${productItem}?view=custom_json`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.text(); // Fetch the response as text
        })
        .then(text => {
          // Attempt to parse the text as JSON
          try {
            
            const data = JSON.parse(text);
            
            if (data && data.tags && data.available) {
              const product_fit = data.tags.find(tag => tag.includes('fit_'));
              if (fit == product_fit.toLowerCase().replace("fit_", "")) {
                let productDetails = {
                  "variants": [],
                  "featured_image": `${data.featured_image}`
                };
                data.variants.forEach(variant => {
                  productDetails.variants.push({
                    "id": `${variant.id}`,
                    "name": variant.option2 ? variant.option2 : '',
                    "available": variant.available,
                    "price": variant.price
                  });
                });
                const colorItem = {
                  "rp_value": data.handle,
                  "rp_label": data.variants[0].options[0]
                };
                related_prods_color.push(colorItem);
                window.gwpData[`${data.handle}`] = productDetails;
              }
            }
          } catch (error) {
            console.error(`Error parsing JSON: or the product with handle ${productItem} does'nt exist`, error);
            console.log('productItem', productItem);
            
          }
        })
        .catch(err => {
          console.log('Fetch error:', err);
        });
    }
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }  

    if(type == 'main' && !this._mercer_boxer_gwp || type == 'boxer' && this._mercer_boxer_gwp) {
      window.gwpData['related_prods_color'] = related_prods_color;
      if(document.querySelector("#gwp-primary-colors")) {
        const mainFormSwitcher = document.querySelector("#gwp-primary-colors").closest("gwp-form-switcher");
        document.querySelector("#gwp-primary-colors").innerHTML = `
          ${ related_prods_color.map(color => {
            return `<span class="option" data-value="${ color.rp_value }">${ color.rp_label }</span>`;
          }).join('') }
        `;
        document.querySelectorAll("#gwp-primary-colors span").forEach(colorItem => {
          colorItem.addEventListener('click', function(e){
            e.preventDefault();
            mainFormSwitcher.chooseValue(e.target);
          });
        });
      }
    } else if(type == 'second') {
      window.gwpData['related_opt_prods_color'] = related_prods_color;
      if(document.querySelector("#gwp-secondary-colors")) {
        const mainFormSwitcher = document.querySelector("#gwp-secondary-colors").closest("gwp-form-switcher");
        document.querySelector("#gwp-secondary-colors").innerHTML = `
          ${ related_prods_color.map(color => {
            return `<span class="option" data-value="${ color.rp_value }">${ color.rp_label }</span>`;
          }).join('') }
        `;
        document.querySelectorAll("#gwp-secondary-colors span").forEach(colorItem => {
          colorItem.addEventListener('click', function(e){
            e.preventDefault();
            mainFormSwitcher.chooseValue(e.target);
          });
        });
      }
    } else if (type == 'boxer') {
      window.gwpData['related_boxer_prods_color'] = related_prods_color;
    }
  }
  renderBoxerGWPColorOptions() {
    
    if(document.querySelector("#gwp-primary-colors")) {
      const mainFormSwitcher = document.querySelector("#gwp-primary-colors").closest("gwp-form-switcher");
      document.querySelector("#gwp-primary-colors").innerHTML = `
        ${ window.gwpData.related_boxer_prods_color.map(color => {
          return `<span class="option" data-value="${ color.rp_value }">${ color.rp_label }</span>`;
        }).join('') }
      `;
      document.querySelectorAll("#gwp-primary-colors span").forEach(colorItem => {
        colorItem.addEventListener('click', function(e){
          e.preventDefault();
          mainFormSwitcher.chooseValue(e.target);
        });
      });
    }
  }
  reInitMainGWPColorOptions() {
    if(document.querySelector("#gwp-primary-colors")) {
      const mainFormSwitcher = document.querySelector("#gwp-primary-colors").closest("gwp-form-switcher");
      document.querySelector("#gwp-primary-colors").innerHTML = `
        ${ window.gwpData.related_prods_color.map(color => {
          return `<span class="option" data-value="${ color.rp_value }">${ color.rp_label }</span>`;
        }).join('') }
      `;
      document.querySelectorAll("#gwp-primary-colors span").forEach(colorItem => {
        colorItem.addEventListener('click', function(e){
          e.preventDefault();
          mainFormSwitcher.chooseValue(e.target);
        });
      });
    }
  }
  async updateGWPDataFetch(){
    Promise.all([
      this.updateGWPData(window.gwpData.main_product.related_prods , 'main'),
      this.updateGWPData(window.gwpData.second_product.related_prods , 'second'),
      this.updateGWPData(window.gwpData._mercer_boxer_gwp_product.related_prods , 'boxer')
    ]).then(() => {
      console.log('All promises resolved');
      this.fetchGWPRelatedProducts = true;

      const myCustomEvent = new CustomEvent("dataFetched", {
        detail: { }
      }); 

      document.dispatchEvent(myCustomEvent); 




    });


  }

  quantityBtnAssign() {
    this.quantityBtns = this.querySelectorAll(".sidecart__update-btn");
    this.quantityBtns.forEach((btn) => {
      btn.addEventListener("click", this.updateCart.bind(this, btn));
    });
  }

  setupShippingProtectionModal() {
    // Open modal button
    const openBtn = this.querySelector("#shipping-protection-modal-open");
    if (openBtn) {
      openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.openShippingProtectionModal();
      });
    }

    // Close modal button
    const closeBtn = this.querySelector(".shipping-protection--modal-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeShippingProtectionModal();
      });
    }

    // Close modal when clicking outside
    const modalContainer = this.querySelector(".shipping-protection--modal-container");
    if (modalContainer) {
      modalContainer.addEventListener("click", (e) => {
        if (e.target === modalContainer) {
          this.closeShippingProtectionModal();
        }
      });
    }

    // Close modal with ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modalContainer && modalContainer.classList.contains("open")) {
        this.closeShippingProtectionModal();
      }
    });
  }

  openShippingProtectionModal() {
    const modalContainer = this.querySelector(".shipping-protection--modal-container");
    if (modalContainer) {
      modalContainer.classList.add("open");
      document.body.style.overflow = "hidden";
    }
  }

  closeShippingProtectionModal() {
    const modalContainer = this.querySelector(".shipping-protection--modal-container");
    if (modalContainer) {
      modalContainer.classList.remove("open");
      document.body.style.overflow = "";
    }
  }

  closeBtnIcon() {
    return `
      <svg class="new-test" xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
      <path d="M6.58803 0.0412474C8.147 -0.0883822 9.87801 0.137988 11.4552 0.0392943C12.4869 0.0830994 13.4308 1.00036 13.4308 2.03537V2.7004H16.1476C16.6316 2.70059 17.2702 3.02611 17.5822 3.38496L17.6691 3.49238C18.5226 4.61071 17.9488 6.18017 16.6017 6.58708L16.6056 19.3623C16.51 20.7357 15.6046 21.8269 14.1906 21.9961L3.97768 22L3.72475 21.9717C2.48256 21.7733 1.59321 20.7308 1.48158 19.4883L1.48353 6.5861C0.246937 6.21939 -0.380871 4.89389 0.246228 3.73359C0.528154 3.21339 1.19779 2.75986 1.81459 2.70528L1.93666 2.7004H4.65346V1.46897C4.70026 1.51123 4.7467 1.24623 4.80385 1.2844C5.13228 0.616727 5.69653 0.168099 6.43764 0.0588253L6.58803 0.0412474ZM2.52357 19.4463C2.52357 20.1248 3.27104 20.9516 3.98451 20.9629L14.0197 20.9697L14.0187 20.9961H14.0197V20.9697C14.8157 20.9471 15.4738 20.229 15.5529 19.4698L15.5607 19.3174V6.64469H2.52357V19.4463ZM1.9933 3.7414C0.844687 3.80861 0.711672 5.35844 1.84975 5.57342H16.2345C17.3883 5.3447 17.1951 3.73226 16.0158 3.72969L1.9933 3.7414ZM11.4123 1.0676C9.88522 0.930178 8.14158 1.17064 6.59194 1.07444C6.1357 1.12774 5.75726 1.49939 5.69643 1.94943L5.68569 2.13009C5.6866 2.31788 5.71337 2.52264 5.69643 2.7004H12.3878V2.03537C12.3878 2.01046 12.3263 1.76777 12.3107 1.72482C12.1724 1.33934 11.8189 1.10453 11.4123 1.0676Z" fill="#111111"/>
      <path d="M8.64258 8.33156C8.69819 7.70958 9.36918 7.67356 9.42871 8.37648V18.3032C9.42086 18.7676 9.00679 19.0464 8.75293 18.7056V18.7066C8.71371 18.6538 8.68988 18.5614 8.66504 18.4937L8.64258 8.33156Z" fill="#111111"/>
      <path d="M6 8.33156C6.05561 7.70958 6.7266 7.67356 6.78613 8.37648V18.3032C6.77828 18.7676 6.36421 19.0464 6.11035 18.7056V18.7066C6.07113 18.6538 6.0473 18.5614 6.02246 18.4937L6 8.33156Z" fill="#111111"/>
      <path d="M12.0376 7.87762C12.3723 7.77375 12.5594 8.08373 12.5718 8.5036L12.5698 18.2604C12.5582 18.8315 12.0954 19.0636 11.8501 18.6384L11.8042 18.5446L11.7856 8.28387C11.7857 8.12388 11.9272 7.91235 12.0376 7.87762Z" fill="#111111"/>
    </svg>
    `; 
    /* return `
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
    </svg>
    `; */
  }
  plusBtnIcon() {
    return `
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
    </svg>
    `;
  }
  minusBtnIcon() {
    return `
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
    </svg>
    `;
  }
  iconCaret() {
    return `
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
      </svg>
    `;
  }

  closeCart() {
    if (this.classList.contains("cart--open"))
      this.classList.remove("cart--open");
    this.closest("body").classList.remove("sidecart-open");
  }
  openCart() {
    if (!this.classList.contains("cart--open")) {
      // render cart again here to get the latest cart data
      this.getCart();
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
      this.classList.add("cart--open");
      this.closest("body").classList.add("sidecart-open");
      this.joinCartNote();
      this.setLocalStorageUrlCountry();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'event':'open_cart'});
    }
  }

  async joinCartNote() {
    let selectedCharts = localStorage.getItem("sizechart");

    if (selectedCharts && selectedCharts.clickedCharts.length > 0) {
      const jsonData = JSON.parse(selectedCharts);
      if(jsonData.clickedCharts.length == 0) return; 
     

      const attributes = JSON.parse(selectedCharts);
      let chart_obj = {
        attributes: {
          _selected_chart: JSON.parse(selectedCharts),
        },
      };
      if (attributes.availableChart.includes("wair")) {
        chart_obj.attributes._sizechart_wair = true;
      }
      if (attributes.availableChart.includes("custom")) {
        chart_obj.attributes._sizechart_custom = true;
      }

      if (attributes.clickedCharts.length != 0) {
        chart_obj.attributes._sizechart_clicked = true;
      }

     

      let body = JSON.stringify(chart_obj);
      await fetch(`/cart/update`, { ...fetchConfig(), ...{ body } }).then(
        (response) => {
          return;
        }
      );
    }
  }

  async addToCartForm(data) {
    const properties = {
      ...fetchConfig("javascript"),
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch("/cart/add.js", properties);
      const responseData = await response.json();

      if (!response.ok) {
        if (window.AddResponseHandler) {
          window.AddResponseHandler.handleCartAddError(data, response, responseData, null, 'form_add');
        }
        return false;
      }

      // get the cart data and then render on the side cart
      this.getCart();
      return true;
    } catch (err) {
      console.error(err);
      if (window.AddResponseHandler) {
        window.AddResponseHandler.handleCartAddError(data, null, null, err, 'form_add');
      }
      return false; // Retorna false si hay error
    }
  }

    async addToCart(itemId, quantity = 1, itemProps = {}, cartAttrs = {}) {
      const fd = new FormData();
      // item
      fd.append('id', itemId);
      fd.append('quantity', String(quantity));
    
      // line item properties
      Object.entries(itemProps || {}).forEach(([k, v]) => {
        fd.append(`properties[${k}]`, String(v));
      });
    
      // cart attributes (globales)
      Object.entries(cartAttrs || {}).forEach(([k, v]) => {
        fd.append(`attributes[${k}]`, String(v));
      });
    
      // evita navegación de servidor; ignoraremos el 302
      fd.append('return_to', 'back');
    
      try {
        const res = await fetch(`${this.domain}cart/add`, {
          method: 'POST',
          body: fd,
          credentials: 'same-origin',
          redirect: 'manual',     // no sigas el 302
          headers: { 'Accept': 'application/json' } // si tu theme lo soporta devolverá JSON; si no, igual se setean attrs
        });
    
        // luego, lee el carrito para refrescar UI (solo lectura)
        await this.getCart();
        return res.ok;
      } catch (err) {
        console.error(err);
        return false;
      }
    }
    

  async getCart() {
    try {
      let data = '';

      const response = await fetch(`${this.domain}cart?sections=cart-json`)
      
      .then(response => response.text())
        .then(html => {
          
            let jsonData = JSON.parse(html);

            const htmlDiv = jsonData['cart-json'];

            // parse the HTML , need only the div textContent
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlDiv, 'text/html');
            
            
            data = JSON.parse(doc.querySelector('#shopify-section-cart-json').textContent);
            console.log(data);
            // render side cart
            this.renderCartOrEmptyOut(data);
          })


      
    } catch (err) {
      console.log(err);
    }
  }

  updateCart(btn, event) {
    event.preventDefault();

    const updateType = btn.dataset.updateType;

    if (
      this.isRemoving
    ) {
      return;
    } else {
      this.isRemoving = true;
    }

    this.querySelectorAll(".sidecart__update-btn.remove").forEach((el) => {
      el.style.pointerEvents = "none";
      el.style.opacity = "0.4";
    });

    this.querySelectorAll(".sidecart__quantity").forEach((el) => {
      el.style.pointerEvents = "none";
		  el.style.opacity = "0.4";
    });

    const variantId = btn.dataset.variantId;
    const lineNumber = parseInt(btn.dataset.lineNumber);
    const bundleIndex = btn.getAttribute("bundle-index");
    const variantQty = parseInt(
      btn.closest(".sidecart__item").querySelector("#itemQuantity").dataset
        .quantity
    );

    // extra safety - exit the function if variant quantity doesn't exist
    if (!variantQty || isNaN(variantQty)) {
      return;
    } else {
      switch (updateType) {
        case "remove":
          this.updateCartThenRender(variantId, lineNumber, 0);
          btn.closest(".sidecart__item").style.cssText =
            "opacity: 0.3;background: rgba(238, 238, 238, 0.933);text-decoration-line: line-through;";
          break;
        case "removeBundle":
          console.log("remove bundle");
          this.removeBundleItems(bundleIndex);
          break;
        case "plus":
          this.updateCartThenRender(variantId, lineNumber, variantQty + 1);
          break;
        case "minus":
          variantQty > 1 &&
            this.updateCartThenRender(variantId, lineNumber, variantQty - 1);
          break;
        default:
          // don't do anything if button updatetype attribute doesn't belong to any of the cases above
          return;
      }
    }
    //this.joinCartNote();
  }

  // M&B - Remove every item of a bundle
  async removeBundleItems(bundleIndex) {
    let loader = this.querySelector(".bundle-loading");
    loader.classList.add("hidden");
    let counter = 0;
    let cartData = '';
    const response = await fetch("/cart?sections=cart-json")
    .then(response => response.text())
      .then(html => {
          let jsonData = JSON.parse(html);

          const htmlDiv = jsonData['cart-json'];

          // parse the HTML , need only the div textContent
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlDiv, 'text/html');

          cartData = JSON.parse(doc.querySelector('#shopify-section-cart-json').textContent);
          console.log(cartData);
          
        })
    let data = {
      updates: {},
    };
    let its = this.querySelectorAll(".sidecart__item");

    // .sidecart__item with bundleindex attribute = bundleIndex
    let element = document.querySelector(
      `.sidecart__item[bundleindex="${bundleIndex}"]`
    );
    if (element) element.style.cssText =
      "opacity: 0.3;background: rgba(238, 238, 238, 0.933);text-decoration-line: line-through;";
    cartData.items.forEach((it) => {
      if (it.properties._bundle_index == bundleIndex) {
        let at = { [it.key]: 0 };
        Object.assign(data.updates, at);
      }
    });
    await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resData) => {
        this.renderCartOrEmptyOut(resData);
        this.isRemoving = false; 
        this.querySelectorAll(".sidecart__update-btn.remove").forEach((el) => {
          el.style.pointerEvents = "";
          el.style.opacity = "";
        });
        this.querySelectorAll(".sidecart__quantity").forEach((el) => {
          el.style.pointerEvents = "";
          el.style.opacity = "";
        });
      });
  }

  updateCartThenRender(variantId, lineNumber = null, quantity) {
    const checkoutBtn = document.querySelector('.sidecart__checkout--btn');
    if (checkoutBtn) checkoutBtn.disabled = true;
  
    const updates = lineNumber
      ? { line: lineNumber, quantity }
      : { id: variantId, quantity };

    const properties = {
      ...fetchConfig("javascript"),
      body: JSON.stringify(updates),
    };

    fetch(`${this.domain}cart/change.js`, properties)
      .then(response => response.json())
      .then(data => {
        const giftIndex = data.items.findIndex(item =>
          item?.properties?._gift_item || item.final_price === 0
        );
  
        const shouldRemoveGift = (
          giftIndex >= 0 &&
          data.total_price - (data.items[giftIndex]?.final_line_price || 0) < 10000
        );
  
        if (data.item_count > 0 && giftIndex >= 0 && shouldRemoveGift) {
          //const giftItem = data.items[giftIndex];
          //return this.removeGiftItem(giftItem, giftIndex);
          /**
           * aqui estamos evitando un Fetch , porque 
           * ya la function se encarga de no dar el descuento de gift item si no se cumple el threshold
           */
        }
  
        this.renderCartOrEmptyOut();
        this.isRemoving = false;
      })
      .catch(err => {
        console.error("Error updating cart:", err);
        if (checkoutBtn) checkoutBtn.disabled = false;
        this.isRemoving = false;
      });
  }
  

  async removeGiftItem(giftItem, index) {
    const checkoutBtn = document.querySelector('.sidecart__checkout--btn');
    const payload = giftItem.final_price === 0
      ? { line: index + 1, quantity: 0 }
      : { line: index + 1, properties: { _gift_item: false } };
  
    return fetch(`${this.domain}cart/change.js`, {
      ...fetchConfig("javascript"),
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(updatedCart => {
        console.log("Gift removed:", updatedCart);
        this.renderCartOrEmptyOut();
      })
      .catch(err => {
        console.error("Error removing gift item:", err);
        this.renderCartOrEmptyOut();
      })
      .finally(() => {
        if (checkoutBtn) checkoutBtn.disabled = false;
      });
  }

  renderCartOrEmptyOut(cartData, hasTriedRemovingGift = false) {
    if (typeof cartData === 'undefined' || !cartData || cartData == undefined) {
      fetch(`${this.domain}cart?sections=cart-json`)
        .then((response) => response.text())
        .then((html) => {
          let jsonData = JSON.parse(html);

          const htmlDiv = jsonData['cart-json'];

          // parse the HTML , need only the div textContent
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlDiv, 'text/html');

          const data = JSON.parse(doc.querySelector('#shopify-section-cart-json').textContent);
          const giftIndex = data.items.findIndex(item =>
            item?.properties?._gift_item || item.final_price === 0
          );
    
          const shouldRemoveGift = (
            giftIndex >= 0 &&
            data.total_price - (data.items[giftIndex]?.final_line_price || 0) < 10000
          );
    
          if (data.item_count > 0 && giftIndex >= 0 && shouldRemoveGift && !hasTriedRemovingGift) {
            const giftItem = data.items[giftIndex];
            return this.removeGiftItem(giftItem, giftIndex);
          }

          this.renderCartOrEmptyOut(data, true);
          return;
        });
    } else if (cartData.item_count > 0) {
      this._mercer_boxer_gwp = false;
      
      this.reRenderItemsContainer(cartData);
      this.reRenderFooter(cartData);

      // Remove the current GWP widget if
      const gwpWidget = this.querySelector(".sidecart__gwp");
      
      if (gwpWidget) {
        gwpWidget.remove();
      }
      
      // GWP Rendering if item_count < 3
      const gwpID = gwpData.main_product;
      const gwpThreshold = gwpData.price_threshold * window.theme.exchange_rate;
      let hasGiftCard = false;
      if (gwpID.id) {
        const itemExists = cartData.items.find((item) => {
          if (gwpID.related_prods.split(',').includes(item.handle)) return item;

          const gwpRelatedIDs = Object.keys(gwpData);
          const relatedProdExists = gwpRelatedIDs.find(
            (relProdId) => relProdId === item.handle
          );
          if (relatedProdExists) return item;
        });
        const giftExists = cartData.items.find((item) => {

          const giftItemProperty = item.properties.find(property => property[0] === "_gift_item");
        if (item.gift_card == true || (giftItemProperty && giftItemProperty[1] === 'true' || item.final_price == 0)) {
            hasGiftCard = true;
            return item; 
        }
          const hasGiftDiscount = item.discounts.find(
            (dc) => dc.title === "Gift With Purchase"
          );
          if (hasGiftDiscount) return item;
          // if(item.properties["gift_item"] !== undefined) return item;
        });

        let mens_item_count = 0;
        let womens_item_count = 0;
        cartData.items.forEach((item) => {
          if (item.product_type.includes("Mens")) {
            mens_item_count += item.quantity;
          } else if (item.product_type.includes("Womens")) {
            womens_item_count += item.quantity;
          }
        });

        if (womens_item_count > mens_item_count) {
          gwpData.widget_type = gwpData.women_widget_type;
        } else {
          gwpData.widget_type = gwpData.men_widget_type;
        }
        
        switch (gwpData.widget_type) {
          case "cross_sell":
            if (
              !itemExists &&
              cartData.item_count < 4 &&
              cartData.item_count > 0
            ) {
              this.renderGWP(cartData);
              /* if(true) {
                this.renderGWP(cartData);
              } else {
                const handleDataFetched = (event)=>{
                  console.log('Data fetched Event listened');
                  document.removeEventListener("dataFetched", handleDataFetched);
                  this.renderGWP(cartData);
                }
                
                document.addEventListener("dataFetched", handleDataFetched, { once: true });
              } */
              
            }
            break;
          case "gwp":
            if (!giftExists && cartData.total_price / 100 >= gwpThreshold) {
              if (!hasGiftCard) {
                this.renderGWP(cartData);
                /* if(true) {
                  this.renderGWP(cartData);
                } else { 
                  const handleDataFetched = (event)=>{0
                    console.log('Data fetched Event listened');
                    document.removeEventListener("dataFetched", handleDataFetched);
                    this.renderGWP(cartData);
                  }
                  
                  document.addEventListener("dataFetched", handleDataFetched, { once: true });
                } */
              }
            }
            break;
        }
      } else {
        console.log("the id does not exist");
      }

      this.cartContent.classList.add("show-upsell");
      // if(Rebuy.widgets[0]) Rebuy.widgets[0].methods.reload();

         // update the quantity on cart icon bubble
    this.updateNumberItems(cartData.item_count)
    this.updateCartIconBubble(cartData);
    // update the free shipping message regardless of the cart status
    this.updateFreeShipping(cartData);
    } else {
      this.emptyCart();
      // Remove the current GWP widget if
      const gwpWidget = this.querySelector(".sidecart__gwp");
      
      if (gwpWidget) {
        gwpWidget.remove();
      }
      this.cartContent.classList.remove("show-upsell");
         // update the quantity on cart icon bubble
    this.updateNumberItems(cartData.item_count)
    this.updateCartIconBubble(cartData);
    // update the free shipping message regardless of the cart status
    this.updateFreeShipping(cartData);
    }
 
  }

  emptyCart() {
    // empty out the footer
    this.cartFooter.innerHTML = "";

    this.itemsContainer.innerHTML = `
      <div class="empty__cart">
        ${this.emptyCartContent.innerHTML}
      </div>
    `;
    // this.itemsContainer.innerHTML = ` `;
  }

  reRenderItemsContainer(cartData) {
    console.log(cartData);
    let existProductFromRebuy = false;
    let rebuyUsedWidgets = [];
    const cartItems = cartData.items?.map((item, index) => {
      switch (item.properties._igLineItemDiscount) {
        case 0:
        case "":
        case null:
        case undefined:
          var intelligems_discount = false;
          break;
        default:
          var intelligems_discount = true;
      }
      // if _shipping_protection is true, dont show the item
      let hideQuantity = false;
      if (item.properties.some(([key, value]) => key === '_shipping_protection')) {
        this.hasShippingProtection = true;
        hideQuantity = true;
      } 
      const isFromRebuy = Array.isArray(item.properties) &&
        item.properties.some(([key, value]) => key === '_source' && value === 'Rebuy');
      if (isFromRebuy) {
        existProductFromRebuy = true;
        const widgetId = item.properties.find(([key, value]) => key === '_widget_id');
        if (widgetId) {
          rebuyUsedWidgets.push(widgetId[1]); 
        }
        
      }
      const isBundle = item.properties?._bundle_index != null ? true : false;
      const option1 = item.options_with_values[0]
        ? item.options_with_values[0].value
        : "";
      const option2 = item.options_with_values[1]
        ? item.options_with_values[1].value
        : "";
      const option3 = item.options_with_values[2]
        ? item.options_with_values[2].value
        : "";
      const isGiftItem =
        item.original_price !== item.final_price ? true : false;
      
      // Get preorder message from properties array
      const preorderProperty = Array.isArray(item.properties) 
        ? item.properties.find(([key, value]) => key === 'Pre-Order')
        : null;
      let preorderMessage = preorderProperty ? preorderProperty[1] : null;
      
      if (!item.properties?.teepack && !item.properties?.hideOnCart) {
        
        const isNativeBundle = item.item_components.length > 0 ? true : false;
        let isNativeMultiBundle = false;
        if (isNativeBundle) isNativeMultiBundle = item.item_components[0].properties._multibundleItem ? true : false;

        // TODO: fix the multibundles staff for several sizes
        let packSize = null;
        let waist = null;
        let inseam = null;
        let jeanOrPantsStringArray = false;
        let isjeanOrPants = false;

        let originalPriceByProperty = null;
        let discountedPriceByPRoperty = null;
        let calculatedSumPercentage = null;
        let calculatedComparedPrice = null;
        let mbDiscountRef = null;
        let packDiscount = null;

        
       
        if (isNativeBundle || isNativeMultiBundle) {

          mbDiscountRef = item?.item_components[0]?.properties?._multibundle_discount_ref;
          jeanOrPantsStringArray = ["Mens-Pants", "Mens-jeans", "Mens-Chinos", "Womens-jeans", "Mens-sweats", "Mens-shorts", "Mens-pants"];
          isjeanOrPants = jeanOrPantsStringArray.includes(item.item_components[0].product_type) ? true : false;
          //discountedPriceByPRoperty = item.item_components[0].properties['Discounted price'];
          // return the sum of all the discounted prices validate a number because this value will come with currency and as string
          //discountedPriceByPRoperty = item.item_components.map((i) => i.properties['Discounted price']).reduce((a, b) => a + b, 0); same but convert it to number first
          discountedPriceByPRoperty = item.item_components[0].properties?._total_price;
          
          originalPriceByProperty = item.item_components[0].properties?._original_price;
         

          // Calculate the sum of the percentage discount
          calculatedSumPercentage = ((originalPriceByProperty * 100 ) / discountedPriceByPRoperty) - 100;

          // Calculate the compared price
          calculatedComparedPrice = item.price +  (item.price * calculatedSumPercentage) / 100;
          
          if (item.item_components[0].properties._mercer_boxer_gwp) this._mercer_boxer_gwp = true;
          
          const preorderPropertyMultiBundle = item.item_components[0].properties['Pre-Order'];
          if (preorderPropertyMultiBundle) {
            preorderMessage = preorderPropertyMultiBundle;
          }
        }
        //const isjeanOrPants = item.item_components[0].product_type == "Mens-Pants" || item.item_components[0].product_type == "Mens-jeans" ||  item.item_components[0].product_type == "Mens-Chinos" ? true : false;
        
        if (isNativeBundle && !isjeanOrPants) {
          packSize = item.item_components[0].options_with_values.find(
            (option) => option.name === "Size" || option.name === "Tamaño" || option.name === "Taille" 
          ).value;
          packDiscount = item.item_components[0]?.properties?._discount;
        }else if (isNativeBundle && isjeanOrPants) {
          // options waist and inseam
          waist = item.item_components[0].options_with_values.find(
            (option) => option.name === "Waist" || option.name === "Cintura"
          ).value;
          inseam = item.item_components[0].options_with_values.find(
            (option) => option.name === "Inseam" || option.name === "Entrepierna" || option.name === "Taille"
          ).value;
          packSize = `${waist}X${inseam}`;
          packDiscount = item.item_components[0]?.properties?._discount;
        }
         


        return `
        <div key="${item.key}" class="sidecart__item ${item.properties?.tee_pack ? "hiddenish" : ""
          }" ${isBundle ? 'bundleindex="' + item.properties?._bundle_index + '"' : ""
          }>
          <a class="sidecart__update-btn remove" ${item.properties?._bundle_index ? `bundle-index="${item.properties?._bundle_index
            }"` : ``}  data-update-type="${isBundle ? "removeBundle" : "remove"
          }" data-line-number="${index + 1}" data-variant-id="${item.variant_id
          }">${this.CLOSEBTN}</a>
        <div class="sidecart__item--image">
          ${item.properties?.multibundle_main
            ? `
              <div class="swiper-container swiper-container-minicart-bundle">
                <div class="swiper-wrapper">
                  ${item.properties?.bundle_images
              .map(
                (img) => `
                    <div class="swiper-slide">
                      <img src="${img}" />
                    </div>
                  `
              )
              .join("")}
                </div>
                <div class="swiper-pagination"></div>
              </div>
                `
            :isNativeBundle &&  isNativeMultiBundle ? `
              <div class="swiper-container swiper-container-minicart-bundle">
                <div class="swiper-wrapper">
                  ${item.item_components
              .map(
                (img) => `
                    <div class="swiper-slide">
                      <img src="${img.featured_image.url}" />
                    </div>
                  `
              )
              .join("")}
                </div>
                <div class="swiper-pagination"></div>
              </div>
            `: `
                
                  <img src="${item.featured_image}" />
                
                `
          }
        </div>
          <div class="sidecart__item--details">
            <p class="product-title">${item.product_title}</p>
            <p class="product-price-color ${packDiscount == "100.00" ? 'hidden': ''}">
              ${item.properties?.packPrice
                ? `

                ${(item.properties.bundle_without_discount == true) ? `

                <span class="item-price "> 
                  ${Shopify.formatMoneyAmmount(item.properties?.packPrice)}
                </span>


                ` : ` 

                <span class="item-price bundle__discount">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(item.properties?.packPrice.toFixed(
                  2
              ))} ${item.properties?.originalprice
                  ? `<s class=""> $${Shopify.formatMoneyAmmount(item.properties?.originalprice)} </s>`
                  : ``
                  } 
                </span>

                `}

                ` /* new native bundle staff */
                : isNativeBundle ? `
                ${(mbDiscountRef == "0" || packDiscount == "0" ) ? 
                `
                <span class="item-price bundle__discount-0 " note="new native bundle staff">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(item.price / 100 )}  ${window.theme.shop_currency} </span>
                `
                :
                `
                <span class="item-price bundle__discount " note="new native bundle staff">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(item.price / 100 )}  ${window.theme.shop_currency}<s>${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount((calculatedComparedPrice / 100))}  ${window.theme.shop_currency}</s>  </span>
                `}
                
                `: `
                <span class="item-price${isGiftItem && !intelligems_discount ? " discount" : ""
                  }">
                  ${isGiftItem && !intelligems_discount
                  ? `<span class="original-price">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount((item.original_price / 100))} ${window.theme.shop_currency}</span>` 
                  : ""
                  }
                  ${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(parseFloat((item.final_price / 100)))} ${window.theme.shop_currency}
                </span>
                `
              }
              <span class="item-color">
                ${item.properties?.packSize || packSize || isNativeBundle || item.handle == "digital-gift-card"
                ? `${item.quantity}`
                : item.properties?.multibundle_main
                ? `${item.quantity}`
                : `${option1}`
                }
              </span>
            </p>
            ${item.properties?.innerItems
            ? `
            <p class="bundle-colors"><b >Colors: </b>${item.properties?.innerItems.replace(
              "-",
              " "
            )}</p>
            `
            : isNativeBundle && !isNativeMultiBundle ? `
            <p class="bundle-colors"><b >Colors: </b>${item.title.split(' - ')[1].replace('/',' / ')}</p>
            ` : ""
          }
            ${item.properties?.prodSize
            ? `
            <p><b >Size: </b>${item.properties?.prodSize}</p>
            `
            : ""
          }
          ${packSize && !isNativeMultiBundle
            ? `
            <p ${packDiscount == "100.00" ? 'hidden': ''}><b >Size: </b>${packSize}</p>
            `
            : isNativeMultiBundle ? `
            ${item.item_components.map((i)=>`
              <p>
              <b> ${i.title.split('-')[0]}</b> ${i.variant_title}
              </p>` ).join("")} ` : ""
          }
            ${item.properties?._final_sale == "yes"
            ? '<p class="product-final-sale">FINAL SALE - No returns or exchanges</p>'
            : ""
          }
            ${option2 && option3
            ? `<p class="product-size"><b>Size: </b>${option2}X${option3}</p>`
            : option2 && !option3
              ? `<p class="product-size"><b>Size: </b>${option2}</p>`
              : ""
          }

            ${item.properties?.multibundle_main
            ? `
                  ${item.properties?.items_info
              .map((i) => `<p><b>${i.product.title}</b> ${i.variant.title}</p>`)
              .join('')}
                `
            : ``
          }
            



            <div class="sidecart__quantity ${isGiftItem && !intelligems_discount || isNativeBundle || hideQuantity ? "hidden" : ""
          } ${item.properties?.dummyPack ? "hidden" : ""}">
              <a class="sidecart__update-btn minus ${item.properties?.dummyPack  ? "hidden" : ""
          }" data-update-type="minus" data-line-number="${index + 1
          }" data-variant-id="${item.variant_id}">${this.MINUSBTN}</a>
              <span id="itemQuantity" class="sidecart__qty" data-quantity="${item.quantity
          }">${item.quantity}</span>
              <a class="sidecart__update-btn plus ${item.properties?.dummyPack || hideQuantity ? "hidden" : ""
          }" data-update-type="plus" data-line-number="${index + 1
          }" data-variant-id="${item.variant_id}">${this.PLUSBTN}</a>
            </div>
            ${preorderMessage
            ? `<p class="product-preorder" style="margin-top: 8px; font-size: 11px; color: #666; font-weight: 400;">${preorderMessage}</p>`
            : ""
          }
          </div>
        </div>
        `;
      }
    });
    this.itemsContainer.innerHTML = `
      <div class="sidecart__items-listing">
        ${cartItems.join("")}
      </div>
      
      <div data-rebuy-id="224350" ></div>
      <div data-rebuy-id="224150" ></div>
        ${rebuyUsedWidgets.includes("224350") ? `` : ``}
        ${rebuyUsedWidgets.includes("224150") ? `` : ``}
        `
      ;
    
  

    if (!existProductFromRebuy) {
      this.swiperBundle = new Swiper(".swiper-container-minicart-bundle", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 2000,
        },
      });
    }
 
    // Tie newly created action buttons to corrsponding functions
    this.quantityBtnAssign();
    Rebuy.init();
   
    document.addEventListener('rebuy.add', () => {
      this.getCart();
      document.removeEventListener('rebuy.add', () => {});
    }); 
  }

  rebuyUpsellTemplate = `
  <div class="rebuy-upsell-container">
    <div class="rebuy-upsell-image">
      <img src="https://cdn.shopify.com/s/files/1/0533/2089/files/rebuy-upsell-image.png?v=1718707200" alt="Rebuy Upsell Image">
    </div>
  </div>
  `
  shippingProtectionModalTemplate = `
  <div class="shipping-protection--modal-container">
    <div class="shipping-protection--modal-content">
      <div class="shipping-protection--modal-image">
        <img src="${window.theme.shipping_protection_modal_image}" alt="Package Protection" />
        <button class="shipping-protection--modal-close" type="button">
          <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16M16 1L1 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="shipping-protection--modal-body">
        <h3 class="shipping-protection--modal-title">Shop with confidence</h3>
        <div class="shipping-protection--modal-text">
          <p>Shipping Protection gives you quick support and easy replacements if your package runs into delivery issues.</p>
          
          <p><strong class="text-semibold">Fast Resolutions:</strong> Get help right away if your order is lost or arrives damaged.</p>
          
          <p><strong class="text-semibold">Hassle-Free Support:</strong> Simply email <a href="mailto:help@mottandbow.com">help@mottandbow.com</a>—our team will handle the rest.</p>
          
          <p><strong class="text-semibold">Peace of Mind:</strong> From checkout to delivery, enjoy a worry-free shopping experience.</p>
        </div>
        
        <div class="shipping-protection--modal-footer">
          <hr class="shipping-protection--modal-divider" />
          <div class="shipping-protection--modal-links">
            <a href="/pages/contact-us">Policies</a> | 
            <a href="/pages/terms-and-conditions-of-sale">Terms</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  `
  reRenderFooter(cartData) {
    let enable_shipping_protection = window.theme.enable_shipping_protection;
    const exclusiveCountryes = window.theme.exclusive_countries_shipping_protection_code;
    let updatedFooterHTML = '';
    /*
      Intelligems --- TODO: Remove this after testing
    */
   const igTest = window.igData.user.getTestGroup('47707f75-6a0b-4cff-86e1-edccbbf1947c');
   if (igTest) {
    const { isControl } = igTest;
    if (isControl) {
      enable_shipping_protection = false;
    }
   }
   /*
    End Intelligems --- TODO: Remove this after testing
   */

    if (enable_shipping_protection && exclusiveCountryes.includes(window.localization.contry) || enable_shipping_protection && exclusiveCountryes == "") {
      const variantsFreeShippingJson = window.theme.shipping_protection_variants_json || [];
      const disclamer = window.theme.shipping_protection_disclaimer;
      const variantFreeShipping = variantsFreeShippingJson.find((variant) => {
        const [min, max] = variant.cart_range.split('-').map(Number);
        return (cartData.total_price / 100) >= min && (cartData.total_price / 100) <= max;
      });
        updatedFooterHTML = `
      
      ${this.shippingProtectionModalTemplate}
      <div class="sidecart__footer-container shipping-protection">
      
        <div class="sidecart__subtotal" >
                <div>
                  <p>Subtotal</p> 
                  <p>${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(cartData.total_price / 100)}  ${window.theme.currency_subtotal}</p>
                </div>
        </div>
        <div class="sidecart__checkout">
        <div class="shipping-protection--info">
          <div>
            <p>
              Package Protection
              
              <button class="shipping-protection--modal-toggler" id="shipping-protection-modal-open" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 96-32 0zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"></path>
                </svg>
              </button>
            </p>
            <p class="shipping-protection--modal-toggler messsage">Included in Secure Checkout</p>
          </div>
          <div>
            <p> ${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(variantFreeShipping.price)} ${window.theme.currency_subtotal}</p>
          </div>
        </div>
          <form action="/cart/add" method="post" class="sidecart__form">
            <input type="hidden" name="id" value="${variantFreeShipping.variant_id}"><!-- shipping protection variant -->
            <input type="hidden" name="quantity" value="${this.hasShippingProtection ? 0 : 1}">
            <!-- optional: tag the line item -->
            <input type="hidden" name="properties[_shipping_protection]" value="true">
            <input type="hidden" name="properties[_Disclaimer]" value="${disclamer}">
            <input type="hidden" name="properties[_added_from_mini_cart]" value="true">
            <input type="hidden" name="properties[_enable_remove_on_checkout]" value="true">
            <input type="hidden" name="properties[_selection_source]" value="minicart">
            <!-- after adding, go straight to checkout -->
            <input type="hidden" name="return_to" value="/checkout">

            <button type="submit" class="sidecart__checkout--btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
              <path d="M16.53 6.41H14.85V5.18C14.86 2.32 12.38 0 9.33 0H8.67C5.62 0 3.15 2.32 3.15 5.18V6.41H1.47C0.66 6.41 0 7.03 0 7.78V20.62C0 21.38 0.66 21.99 1.47 21.99H16.54C17.35 21.99 18.01 21.38 18.01 20.62V7.78C18.01 7.02 17.35 6.41 16.54 6.41H16.53ZM5.49 5.29C5.49 3.47 7.06 2 9 2C9.97 2 10.84 2.37 11.48 2.96C12.11 3.56 12.51 4.38 12.51 5.28V6.39H5.5V5.28L5.49 5.29ZM8.18 18.54V14.27C7.21 13.92 6.51 12.94 6.51 11.78C6.51 10.33 7.61 9.15 8.97 9.15C10.33 9.15 11.43 10.33 11.43 11.78C11.43 13.02 10.63 14.06 9.55 14.33V18.54H8.19H8.18Z" fill="white"/>
            </svg>
              SECURE CHECKOUT
            </button>
          </form>

        </div>
         <form action="${this.CARTROUTES}" method="post" >
              <button type="submit" class="sidecart__footer-btn-info" name="checkout" form="cart" >
                Checkout without package protection
              </button>
            </form>
       
      </div>
    `;
    } else {
      updatedFooterHTML = `
    
      <div class="sidecart__footer-container">
      
        <div class="sidecart__subtotal">
                <p>Subtotal: <span>${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(cartData.total_price / 100)}  ${window.theme.currency_subtotal}</span></p>
        </div>
        <div class="sidecart__checkout">
          <form action="${this.CARTROUTES
      }" class="sidecart__form" method="post" id="cart">
          
            <button type="submit" class="sidecart__checkout--btn" name="checkout" form="cart">
              ${this.CHECKOUTBTNTXT}
            </button>
          </form>
        </div>
        <p class="sidecart__footer-btn-info">${window.theme.gift_code}</p>
      </div>
    `;
    }
    
    this.cartFooter.innerHTML = updatedFooterHTML;

    // Shipping protection modal functionality
    this.setupShippingProtectionModal();
  }

  setLocalStorageUrlCountry() {
    if (Shopify && Shopify.routes && Shopify.routes.root) localStorage.setItem("urlCountry", Shopify.routes.root);
  }

  renderGWP(cartData) {
    console.log("renderGWP reached");
    if(window.theme.upsell_global_type == "disabled") return;
    window.gwpData.widget_type = this.originalGWPWidgetType;
    const gwpVariants = window.gwpData;
    const menProduct = gwpVariants.main_product;
    let gwpMainProd = gwpVariants.main_product;
    let gwpSecondProd = gwpVariants.second_product;
    let _mercer_boxer_gwp_product = gwpVariants._mercer_boxer_gwp_product;
    
    let relatedProdsColor = gwpVariants.related_prods_color
      ? gwpVariants.related_prods_color
      : [];
    const menRelatedProdsColor = gwpVariants.related_prods_color
    ? gwpVariants.related_prods_color
    : [];
    let relatedOptProdsColor = gwpVariants.related_opt_prods_color
      ? gwpVariants.related_opt_prods_color
      : [];
    let relatedrelated_mercer_boxer_gwp_productColor = gwpVariants.related_boxer_prods_color
      ? gwpVariants.related_boxer_prods_color
      : [];
    const menRelatedProds = gwpMainProd.related_prods.split(",");
    let relatedProds = gwpMainProd.related_prods.split(",");
    let relatedOptProds = gwpSecondProd.related_prods.split(",");
    let related_mercer_boxer_gwp_product = _mercer_boxer_gwp_product.related_prods.split(",");
    let mainProdExistInCart = cartData.items.findIndex((cartItem) => {
      return relatedProds.includes(cartItem.handle);
    });
    let secondProdExistInCart = cartData.items.findIndex((cartItem) => {
      return relatedOptProds.includes(cartItem.handle);
    });
    let mens_item_count = 0;
    let womens_item_count = 0;
    cartData.items.forEach((item) => {
      if (item.product_type.includes("Mens")) {
        mens_item_count += item.quantity;
      } else if (item.product_type.includes("Womens")) {
        womens_item_count += item.quantity;
      }
    });


    if (
      womens_item_count > mens_item_count //&& !this._mercer_boxer_gwp
    ) {
      
      gwpMainProd = gwpSecondProd;
      relatedProdsColor = relatedOptProdsColor;
      relatedProds = relatedOptProds;
      gwpVariants.widget_type = gwpVariants.women_widget_type;
    } else {
      gwpMainProd = _mercer_boxer_gwp_product;
      relatedProdsColor = relatedrelated_mercer_boxer_gwp_productColor;
      relatedProds = related_mercer_boxer_gwp_product;
      gwpVariants.widget_type = gwpData.men_widget_type;
    } 
    
    /*else if (this._mercer_boxer_gwp) {
      
      gwpMainProd = _mercer_boxer_gwp_product;
      relatedProdsColor = relatedrelated_mercer_boxer_gwp_productColor;
      relatedProds = related_mercer_boxer_gwp_product;
      gwpVariants.widget_type = "gwp";

      *
    } */
    
    const gwpWidget = document.createElement("div");
    gwpWidget.classList.add("sidecart__gwp");
    let productObject = gwpVariants[gwpMainProd.handle]
 
  
    gwpWidget.innerHTML = `
      ${true
        ? `
        <p class="gwp-title hidden">${gwpVariants.widget_type === "cross_sell"
          ? "You may also like..."
          : "Add your free gift!"
        }</p>
        ${true
          ? `
          <div class="gwp__container">
          
            <div class="gwp-img__container">
              <img src="${gwpMainProd.featured_image}" loading="lazy" />
            </div>
            <div class="gwp-form__container">
              <div class="gwp-text">
                <p class="gwp-item_title">${gwpMainProd.title}</p>
                <p class="gwp-item_price">
                  ${gwpVariants.widget_type !== "cross_sell"
            ? `<span class="gwp-item_price  free">FREE</span>`
            : `${gwpMainProd.price}`  
          }
                </p>
              </div>
              
                <gwp-form-switcher class="gwp-dropdown" data-type="color">
                  <div class="dropdown-btn current-color" data-value="${gwpMainProd.first_variant.color}">
                    <span class="color-picker ${gwpMainProd.first_variant.color
            .trim()
            .replace(" ", "-")
            .toLowerCase()} "></span>
                    <span class="color-value"></span>
                    ${this.iconCaret()}
                  </div>
                  <div class="dropdown-options color-dropdown">
                    ${[...new Set(gwpMainProd.variants.map(({ option1 }) => `${option1}`))].map(color => `
                      
                    <span class="option" title="${color}" data-product="${gwpMainProd.name}" data-value="${color}">
                          <span class="color-picker ${color.trim().replace(" ", "-").toLowerCase()} "></span> <span class="color-value-text">${color}</span> 
                        </span>
                      `
            )
            .join("")}
                  </div>
                </gwp-form-switcher>
                <gwp-dropdown class="gwp-dropdown" data-type="size" data-atc-interactor>
                  <div class="dropdown-btn" data-handle="${gwpMainProd.packdummy_handle}" data-id="${gwpMainProd.id}" data-title="${gwpMainProd.title}" data-color="${gwpMainProd.first_variant.color}" data-compare="${gwpMainProd.compare_at_price}"
                     data-size="${gwpMainProd.first_variant.size}" data-type="${gwpMainProd.title.toLowerCase().includes('pack') ? 'pack' : 'single'}" data-value="${gwpMainProd.first_variant.id
          }">
                    <span>${gwpMainProd.first_variant.size}</span>
                    ${this.iconCaret()}
                  </div>
                  <div class="dropdown-options">
                    ${gwpMainProd.variants.filter(variant => variant.option1 == gwpMainProd.first_variant.color).map(variant => `
                      <span class="option" data-size="${variant.option2}" data-value="${variant.id}" ${variant.available ? "" : "disabled"}>
                        ${variant.option2}
                      </span>
                    `
            )
            .join("")}
                  </div>
                </gwp-dropdown>
                
              
              <button class="gwpATC" data-handle="" data-id="" data-size="" data-compare="" data-title="" data-color="" data-type="" data-value="">ADD</button>
            </div>
          </div>  
        `
          : ``
        }
      `
        : ``
      }
    `;
  

    const colorSwitcherHTML = `
      <gwp-form-switcher class="gwp-dropdown" data-type="color">
        <div class="dropdown-btn" data-value="${gwpMainProd.first_variant.color}">
          <span class="color-picker ${gwpMainProd.first_variant.color
            .trim()
            .replace(" ", "-")
            .toLowerCase()}"></span>
          <span class="color-value">${gwpMainProd.first_variant.color}</span>
          ${this.iconCaret()}
        </div>
        <div class="dropdown-options">
          ${[...new Set(gwpMainProd.variants.map(({ option1 }) => `${option1}`))].map(color => `
              <span class="option" data-product="${gwpMainProd.name}" data-value="${color}">
                ${color}
              </span>
            `
              )
              .join("")}
        </div>
      </gwp-form-switcher>
    `
    const sizeDropdownHTML = `
      <gwp-dropdown class="gwp-dropdown" data-type="size" data-atc-interactor>
        <div class="dropdown-btn" data-handle="${gwpMainProd.packdummy_handle}" data-id="${gwpMainProd.id}" data-title="${gwpMainProd.title}" data-color="${gwpMainProd.first_variant.color}" data-compare="${gwpMainProd.compare_at_price}"
           data-size="${gwpMainProd.first_variant.size}" data-type="${gwpMainProd.title.toLowerCase().includes('pack') ? 'pack' : 'single'}" data-value="${gwpMainProd.first_variant.id
      }">
          <span>${gwpMainProd.first_variant.size}</span>
          ${this.iconCaret()}
        </div>
      </gwp-dropdown>
    `;
    const priceHTML = `
      <p class="gwp-item_price">
        ${gwpVariants.widget_type !== "cross_sell"
        ? `<span class="item-price discount">${gwpMainProd.price}</span> $0`
        : `${gwpMainProd.price}`
        }
      </p> 
    `;

   

    
    if (!this.querySelector(".sidecart__gwp") ) {
      this.cartHeader.append(gwpWidget);
      this.gwpInit();
    }
    
    
  }

  updateFreeShipping(cartData) {
    const shippingMessageContainer = this.cartHeader.querySelector(
      ".sidecart__header-shipping"
    );
    const shippingCountry = this.cartHeader.querySelector(
      ".freeshiping_country"
    );
    var useThisShipping =
      shippingCountry.value == "US"
        ? this.FREESHIPPING // 150
        : this.FREESHIPPINGINTERNATIONAL; //50
    var shipping_away = window.theme.free_shipping_away;
    const new_total = ((useThisShipping - cartData.total_price) / 100);

    const freeShippingByBundle = cartData.items.find((item) => {
      // bundle_without_discount property is set to true if the bundle is not eligible for discount
      if (item.properties.bundle_without_discount) return item;
    }
    );
    if (cartData.total_price > 0) {
      shippingMessageContainer.classList.add('items_cart');
    }else {
      shippingMessageContainer.classList.remove('items_cart');
    }

    useThisShipping = useThisShipping * window.theme.exchange_rate;

    console.group("updateFreeShipping");
    console.log("cartData", cartData);
    console.log("useThisShipping", useThisShipping);
    console.log("new_total", new_total);
    console.log("freeShippingByBundle", freeShippingByBundle);
    console.groupEnd();

    
    const isGWP = window.theme.upsell_global_type == "gwp"? true : false;
    const leftPrice = ((useThisShipping - cartData.total_price) / 100);
    const FREE_GIFT_THRESHOLD =  (window.theme.gwp_threshold * 100); 
    const FREE_SHIPPING_THRESHOLD = useThisShipping;

     let updatedShippingHTML = `
       <p>
         ${cartData.total_price < useThisShipping
         ? `You're ${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(leftPrice)} away from <strong>FREE SHIPPING</strong>`
         : `${window.theme.free_shipping}`
       }
       </p>
     `;
       // do the womens and mens item count
    let mens_item_count = 0;
    let womens_item_count = 0;
    cartData.items.forEach((item) => {
      if (item.product_type.includes("Mens")) {
        mens_item_count += item.quantity;
      }
      if (item.product_type.includes("Womens")) {
        womens_item_count += item.quantity;
      }
    });
    let adjustedProgress = 0;
    let markerProgress = 0;
     if (shippingCountry.value == "US" && (mens_item_count >= womens_item_count || (mens_item_count === 0 && womens_item_count === 0))) {

      // if les that 125 You're $XX away from your free Father's Day gift
      // if more than 125 and less than 150  The free gift is yours! Add $XX more for free shipping
      // Congrats, you unlocked a free gift + free shipping!
      if (cartData.total_price <= FREE_GIFT_THRESHOLD) {
          adjustedProgress = (cartData.total_price / FREE_GIFT_THRESHOLD) * 50; 
          markerProgress = adjustedProgress;
      } else if (cartData.total_price <= FREE_SHIPPING_THRESHOLD) {
          adjustedProgress = 50 + ((cartData.total_price - FREE_GIFT_THRESHOLD) / (FREE_SHIPPING_THRESHOLD - FREE_GIFT_THRESHOLD)) * 50;
          markerProgress = adjustedProgress;
      } else {
          adjustedProgress = 100;
          markerProgress = 100;
      }
      let markerHTML = `
        <div class="progress-marker" style="left: ${markerProgress}%; transform: translateX(-50%);">
        <div class="container">
          <div class="line">
            <div class="circle"></div>
          </div>
        </div>
          <div class="marker-value">$${(cartData.total_price / 100).toFixed(2)}</div>
        </div>
      `;
      let progressBarHTML = `
        <div class="progress-container-wrapper">
          <div class="progress-container" style="position:relative;">
              <div class="progress-bar ${adjustedProgress >= 100 ? 'complete' : ''}"
                style="background: linear-gradient(to right, #206203 ${adjustedProgress}%, #BEBCBC ${adjustedProgress}%);">
                  <div class="progress-sections" style="display: flex; width: 100%; height: 100%;">
                      <div class="progress-offer ${cartData.total_price >= FREE_GIFT_THRESHOLD ? 'offer-reached' : ''}" style="width: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px;">
                          ${isGWP ? 'FREE GIFT AT $' + (FREE_GIFT_THRESHOLD / 100) : cartData.total_price >= FREE_GIFT_THRESHOLD ? 'UNLOCKED OFFER ': 'UNLOCK OFFER AT ' + window.theme.cart_currency_symbol + (FREE_GIFT_THRESHOLD / 100)}
                      </div>
                      <div class="progress-shipping" style="width: calc(50% - 4px); display: flex; align-items: center; justify-content: center; font-size: 12px;">
                          ${'Free Shipping at ' + window.theme.cart_currency_symbol + (useThisShipping / 100)}
                      </div>
                  </div>
              </div>
              ${cartData.total_price <= FREE_SHIPPING_THRESHOLD ? markerHTML : ''}
          </div>
        </div>
      `;

    
      if (cartData.total_price < FREE_GIFT_THRESHOLD) {
        updatedShippingHTML = isGWP ? `
        <p>
        <strong>Add ${Shopify.currency.active.toUpperCase()} $${((FREE_GIFT_THRESHOLD - cartData.total_price) / 100).toFixed(0)} more to get a FREE GIFT.</strong>
        </p>
        ${progressBarHTML}` : `
        <p>
        <strong>SPECIAL OFFER</strong> just ahead - <strong>add $${((FREE_GIFT_THRESHOLD - cartData.total_price) / 100).toFixed(2)} more.</strong>
        </p>
        ${progressBarHTML}
        `
      } else if (cartData.total_price < FREE_SHIPPING_THRESHOLD) {
        updatedShippingHTML = isGWP ? `
        <p>
        <strong>Add ${Shopify.currency.active.toUpperCase()} $${(Math.abs(FREE_GIFT_THRESHOLD - cartData.total_price) / 100).toFixed(0)} more to get a FREE SHIPPING.</strong>
        </p>
        ${progressBarHTML}` : `
        <p>
          Add <strong>$${((FREE_SHIPPING_THRESHOLD - cartData.total_price) / 100).toFixed(2)}</strong> more to get <strong>FREE SHIPPING</strong>
        </p>
        ${progressBarHTML}
        `
      } else {
        updatedShippingHTML = `
        <p>
          <strong>${'All deals unlocked-complete your order before they expire'}</strong>
        </p>
        ${progressBarHTML}
        `
      }
    }else if  (shippingCountry.value == "US" && mens_item_count < womens_item_count && womens_item_count > 0) {
      let adjustedProgress = 0;
      if (cartData.total_price <= FREE_GIFT_THRESHOLD) {
          adjustedProgress = (cartData.total_price / FREE_GIFT_THRESHOLD) * 50; 
          markerProgress = adjustedProgress;
      } else if (cartData.total_price <= FREE_SHIPPING_THRESHOLD) {
          adjustedProgress = 50 + ((cartData.total_price - FREE_GIFT_THRESHOLD) / (FREE_SHIPPING_THRESHOLD - FREE_GIFT_THRESHOLD)) * 50;
          markerProgress = adjustedProgress;
      } else {
          adjustedProgress = 100;
          markerProgress = 100;
      }
      let markerHTML = `
      <div class="progress-marker" style="left: ${markerProgress}%; transform: translateX(-50%);">
        <div class="container">
          <div class="line">
            <div class="circle"></div>
          </div>
        </div>
          <div class="marker-value">$${(cartData.total_price / 100).toFixed(2)}</div>
        </div>
      `;

      let progressBarHTML = `
        <div class="progress-container-wrapper">
          <div class="progress-container" style="position:relative;">
              <div class="progress-bar ${adjustedProgress >= 100 ? 'complete' : ''}"
                style="background: linear-gradient(to right, #206203 ${adjustedProgress}%, #BEBCBC ${adjustedProgress}%);">
                                     <div class="progress-sections" style="display: flex; width: 100%; height: 100%;">
                       <div class="progress-offer ${cartData.total_price >= FREE_GIFT_THRESHOLD ? 'offer-reached' : ''}" style="width: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px;">
                          ${isGWP ? 'FREE GIFT AT $' + (FREE_GIFT_THRESHOLD / 100) : cartData.total_price >= FREE_GIFT_THRESHOLD ? 'UNLOCKED OFFER ': 'UNLOCK OFFER AT ' + window.theme.cart_currency_symbol + (FREE_GIFT_THRESHOLD / 100)}
                       </div>
                       <div class="progress-shipping" style="width: calc(50% - 4px); display: flex; align-items: center; justify-content: center; font-size: 12px;">
                          ${'Free Shipping at ' + window.theme.cart_currency_symbol + (useThisShipping / 100)}
                       </div>
                   </div>
              </div>
              ${cartData.total_price <= FREE_SHIPPING_THRESHOLD ? markerHTML : ''}
          </div>
        </div>
      `;

      if (cartData.total_price < FREE_GIFT_THRESHOLD) {
          updatedShippingHTML = isGWP ? `
        <p>
        <strong>Add ${Shopify.currency.active.toUpperCase()} $${((FREE_GIFT_THRESHOLD - cartData.total_price) / 100).toFixed(0)} more to get a FREE GIFT.</strong>
        </p>
        ${progressBarHTML}`: `
          <p>
            <strong>SPECIAL OFFER</strong> just ahead - <strong>add $${((FREE_GIFT_THRESHOLD - cartData.total_price) / 100).toFixed(2)} more.</strong>
          </p>
          ${progressBarHTML}
          `;
      } else if (cartData.total_price < FREE_SHIPPING_THRESHOLD) {
          updatedShippingHTML = isGWP ? `
        <p>
        <strong>Add ${Shopify.currency.active.toUpperCase()} $${(Math.abs(FREE_SHIPPING_THRESHOLD - cartData.total_price) / 100).toFixed(2)} more to get a FREE SHIPPING.</strong>
        </p>
        ${progressBarHTML}` : `
          <p>
            Add <strong>$${((FREE_SHIPPING_THRESHOLD - cartData.total_price) / 100).toFixed(2)}</strong> more to get <strong>FREE SHIPPING</strong>
          </p>
          ${progressBarHTML}
          `;
      } else {
          updatedShippingHTML = `
          <p>
            <strong>${'All deals unlocked-complete your order before they expire'}</strong>
          </p>
          ${progressBarHTML}
          `;
      }
    }
     
     //remove white spaces
    shippingMessageContainer.innerHTML = "&nbsp;"; 
    const bannerSecondMessage = document.querySelector('.announcement-bar__message').innerText.replace(/\s/g, '');
     if (window.theme.freeShippingBanner && shippingCountry.value != "US") {
      shippingMessageContainer.innerHTML = `<p>${window.theme.freeShippingBanner}</p>`;
      return;
     } else if (bannerSecondMessage.replace(/\s/g, '') != "" && shippingCountry.value != "US") {
      shippingMessageContainer.innerHTML = `<p>${bannerSecondMessage}</p>`;
      return;
     } else if (shippingCountry.value != "US") {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              
              const bannerSecondMessage = document.querySelector('.announcement-bar__message').innerText;
              if (bannerSecondMessage.replace(/\s/g, '') != "") { 
                shippingMessageContainer.innerHTML =  `<p>${bannerSecondMessage}</p>`;
                observer.disconnect();
              } 
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });



      
     } else {
      shippingMessageContainer.innerHTML = updatedShippingHTML;
     }
  }

  updateCartIconBubble(cartData) {
    let itemCount = cartData.item_count;
    cartData.items.forEach((item) => {
      if (item.properties?.teepack || item.properties?.hideOnCart) {
        itemCount -= 1 * item.quantity;
      }
    });
    const quantityBubble =
      this.cartIconBubble.querySelector(".cart-count-bubble");
    const bubbleHTML =
      itemCount <= 0
        ? ""
        : `
      <span aria-hidden="true">${itemCount > 10 ? "10+" : itemCount}</span>
      <span class="visually-hidden">${itemCount} ${itemCount > 1 ? "items" : "item"
        }</span>
    `;
    quantityBubble.innerHTML = bubbleHTML;
  }
  updateNumberItems(items){
    cart_items.textContent =  items > 0 ? `(${items})` : ""
  }
}

customElements.define("side-cart", SideCart);

// document.addEventListener('rebuy:cart.add', function(event){
//     console.log('rebuy:cart.add event', event.detail);
// });

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();


